import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Box,
  InputBase,
  TextField,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import CancelIcon from "@material-ui/icons/Cancel";
import SaveIcon from "@material-ui/icons/Save";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import CheckIcon from "@material-ui/icons/Check";
import SettingsIcon from "@material-ui/icons/Settings";

import CardTable from "components/CardTable/CardTable";
import RegularButton from "components/CustomButtons/Button";
import ModalConfig from "components/ModalConfig/ModalConfig";
import { ModalV2 } from "components/Modal/ModalV2";

import { columnsDispensers } from "./columnsDispensers";

import { useToggle } from "hooks/useToggle";
import { useForm } from "hooks/useForm";

import {
  setTagsStation,
  sendConfigUnitV2,
} from "redux/actions/unitsSection/unitsAction";
import { createSelector } from "reselect";
import { updateFlowmeter } from "redux/actions/unitsSection/unitsAction";
import { PERMISSIONS } from "router/permissions";
import { FormFlowmeterUpdate } from "./FormFlowmeterUpdate";
import PercentIcon from "@mui/icons-material/Percent";
import { cleanNumber } from "helpers/cleanNumbers";

const tagsSelector = createSelector(
  (state) => {
    return state.tagsReducer.tagsList.filter(
      (tag) => tag.idStation === state.unitsReducer.station?.id
    );
  },
  (tags) => tags
);

const colors = {
  success: "#4caf50",
  error: "#f6685e",
  info: "#4092E5",
};

export const CardTableToDispensers = (props) => {
  const { UNIT_FLOWMETER_UPDATE } = PERMISSIONS;
  const tags = useSelector(tagsSelector);
  const [edit, handleEdit] = useToggle();
  const [open, setOpen] = useToggle();
  const [openUpdateFlowmeter, setOpenUpdateFlowmeter] = useToggle();
  const dispatch = useDispatch();
  const { tagsStation, configTypes } = useSelector(
    ({ unitsReducer }) => unitsReducer
  );
  const { rules } = useSelector(({ login }) => login);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const updateFlowmeterRule = rules.includes(UNIT_FLOWMETER_UPDATE);
  const {
    inputValues,
    handleInputOnChange,
    handleNewValues,
    handleNumberInputOnChange,
  } = useForm({
    inputImei: "",
    flowmeter: "",
  });
  const { inputImei, flowmeter } = inputValues;
  const { data, onClose, idUnit } = props;
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  const [filteredConfigTypes, setFilteredConfigTypes] = useState([]);

  const handleSendDispensersTags = () => {
    const form = {
      id: data.id,
      tags: tagsStation.filter((tg) => tg.select).map((tg) => tg.id),
    };
    dispatch(sendConfigUnitV2(data.id, form, false, true));
    onClose();
  };

  const handleSaveIMEI = (e) => {
    e.preventDefault();
    const form = {
      imei: inputImei?.trim(),
    };
    dispatch(sendConfigUnitV2(data.id, form, true, true, idUnit));
    handleEdit();
  };

  const handleUpdateFlowmeter = () => {
    dispatch(
      updateFlowmeter(
        idUnit,
        data.id,
        { flowmeter: cleanNumber(flowmeter) },
        setOpenUpdateFlowmeter
      )
    );
  };

  useEffect(() => {
    data?.imei &&
      handleNewValues({
        inputImei: data.imei,
      });
    // eslint-disable-next-line
  }, [data.imei]);

  useEffect(() => {
    data?.tags
      ? dispatch(
          setTagsStation(
            tags
              .map((tg) => {
                return {
                  ...tg,
                  select: data.tags.includes(tg.id),
                };
              })
              .sort((a, b) => {
                if (a.select === b.select) {
                  return 0;
                } else if (a.select) {
                  return -1;
                } else {
                  return 1;
                }
              })
          )
        )
      : dispatch(setTagsStation(tags));
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    setFilteredConfigTypes(
      configTypes.filter((config) => config.confType === "DISPENSER")
    );
  }, [configTypes]);
  return (
    <>
      <CardTable
        hasHeader
        title2={
          <>
            {edit ? (
              <form onSubmit={handleSaveIMEI}>
                <InputBase
                  name="inputImei"
                  value={inputImei}
                  onChange={handleInputOnChange}
                  autoFocus
                />
                <Box style={{ display: "flex", gap: 5 }}>
                  <RegularButton
                    round
                    justIcon
                    onClick={handleEdit}
                    color="transparent"
                    tooltip="Cancelar"
                  >
                    <CancelIcon style={{ color: colors.error }} />
                  </RegularButton>
                  <RegularButton
                    round
                    justIcon
                    onClick={handleSaveIMEI}
                    color="transparent"
                    tooltip="Guardar"
                  >
                    <CheckIcon style={{ color: colors.info }} />
                  </RegularButton>
                </Box>
              </form>
            ) : (
              <>
                <Typography component="span" color="primary">
                  {data?.imei ? data?.imei : "Sin IMEI asigado"}
                </Typography>
                <RegularButton
                  round
                  justIcon
                  onClick={handleEdit}
                  color="transparent"
                  tooltip="Editar IMEI"
                >
                  <EditIcon style={{ color: colors.info }} />
                </RegularButton>
              </>
            )}
          </>
        }
        icon={<LocalShippingIcon />}
        columns={columnsDispensers}
        data={tagsStation}
        pageSize={isSmallScreen ? 5 : 10}
        blockBtn
        hasControl
        controls={
          <>
            <RegularButton
              round
              justIcon
              color="info"
              onClick={handleSendDispensersTags}
              tooltip="Guardar etiquetas"
            >
              <SaveIcon style={{ margin: 0 }} />
            </RegularButton>
            <RegularButton
              round
              justIcon
              color="info"
              onClick={setOpen}
              tooltip="Config"
            >
              <SettingsIcon style={{ margin: 0 }} />
            </RegularButton>
            {updateFlowmeterRule && (
              <RegularButton
                justIcon
                round
                color="info"
                onClick={setOpenUpdateFlowmeter}
              >
                <Typography variant="caption" >
                  km
                </Typography>
              </RegularButton>
            )}
          </>
        }
      />
      <ModalConfig
        isOpen={open}
        item={data}
        onCloseModal={setOpen}
        config={filteredConfigTypes}
        title="Configuración Dispensador"
        idUnit={idUnit}
        dispenser
      />
      <ModalV2
        title="Actualizar cuenta litros"
        open={openUpdateFlowmeter}
        onClose={setOpenUpdateFlowmeter}
        justConfirm
        onSubmit={handleUpdateFlowmeter}
        isLoading={isLoadingComp?.loadingUpdateFlowmeter}
      >
        <FormFlowmeterUpdate
          values={{
            flowmeter,
            handleNumberInputOnChange,
            handleNewValues,
          }}
        />
      </ModalV2>
    </>
  );
};
